<script setup lang="ts">
import RegisterModal from '@/components/Common/RegisterModal.vue';
import { computed } from 'vue';
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue']);

const props = defineProps<{
  modelValue: boolean
  title: string
  execFunction: () => void
}>();

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

function exec() {
  props.execFunction();
  modelValue.value = false;
}
</script>
<template>
  <RegisterModal
    v-model="modelValue"
    modalMaxWidth="45%"
    :title="props.title"
  >
    <template v-slot:content>
      <div class="w-100 d-flex mt-8">
        <div class="mx-auto">
          <div class="fs-4 mb-3">
            {{ i18n.global.t('pages.dailyReports.recreateConfirmModal.body') }}
          </div>
          <div class="fs-6 mb-3 text-danger">
            {{ i18n.global.t('pages.dailyReports.recreateConfirmModal.announce') }}
          </div>
        </div>
      </div>
    </template>
    <template v-slot:buttons>
      <v-btn
        class="ma-2 reset-btn"
        @click="modelValue = false"
      >
        {{ i18n.global.t('common.cancelBtn') }}
      </v-btn>
      <v-btn
        class="ma-2 bg-danger text-white"
        @click="exec"
      >
        {{ i18n.global.t('pages.dailyReports.recreateConfirmModal.exec') }}
      </v-btn>
    </template>
  </RegisterModal>
</template>
